import React from "react";
import reportAPI from "../../../../api/report";
import { FilterDateRange } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExportCountDepartment } from "../../functions/Report.ExportCountDepartment";
import { STYLEBODY } from "../../../../utils/useStyle";

const ReportCountAllDepartment = ({ userDept }) => {
  const [loading, setLoading] = React.useState("");

  const [startYear, setStartYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [endYear, setEndYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [startMonth, setStartMonth] = React.useState({
    label: "ทุกเดือน",
    value: "ALL",
  });
  const [endMonth, setEndMonth] = React.useState({
    label: "ทุกเดือน",
    value: "ALL",
  });

  const [data, setData] = React.useState({
    an: { adult: 0, kid: 0, total: 0 },
    ir: { adult: 0, kid: 0, total: 0 },
    tr: { adult: 0, kid: 0, total: 0 },
    ped: { adult: 0, kid: 0, total: 0 },
    total: {
      adult: 0,
      kid: 0,
      total: 0,
      an: 0,
      ir: 0,
      tr: 0,
      ped: 0,
    },
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getDepartmentReport({
          startYear: String(startYear?.value),
          endYear: String(endYear?.value),
          startMonth: String(startMonth?.value),
          endMonth: String(endMonth?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching department report:", error);
      }
    };
    fetchData();
  }, [
    startYear?.value,
    endYear?.value,
    startMonth?.value,
    endMonth?.value,
    userDept,
  ]);

  const submitExcelData = {
    Adult: {
      an: data?.an?.adult,
      ir: data?.ir?.adult,
      tr: data?.tr?.adult,
      ped: data?.ped?.adult,
      total: data?.total?.adult,
    },
    Children: {
      an: data?.an?.kid,
      ir: data?.ir?.kid,
      tr: data?.tr?.kid,
      ped: data?.ped?.kid,
      total: data?.total?.kid,
    },
    Total: {
      an: data?.total?.an,
      ir: data?.total?.ir,
      tr: data?.total?.tr,
      ped: data?.total?.ped,
      total: data?.total?.total,
    },
  };

  const isAll = userDept === "All";

  return (
    <>
      {isAll ? (
        <div className={``}>
          <div className="my-20">
            <>
              <div className="flex flex-col gap-4">
                <div className="text-black text-lg font-medium">
                  จำนวน PICC Line ที่ใส่ในแต่ละหน่วย <br />
                  <div className={STYLEBODY}>
                    รายงานตั้งแต่ ปี "{startYear.label}" เดือน "
                    {startMonth.label}" ถึง ปี "{endYear.label}" เดือน "
                    {endMonth.label}" แยกเด็กและผู้ใหญ่
                  </div>
                </div>
                <div className=" flex items-end gap-2 my-3 ">
                  <FilterDateRange
                    startYear={startYear}
                    setStartYear={setStartYear}
                    endYear={endYear}
                    setEndYear={setEndYear}
                    startMonth={startMonth}
                    setStartMonth={setStartMonth}
                    endMonth={endMonth}
                    setEndMonth={setEndMonth}
                  />
                  <ButtonExcel
                    onClick={() => {
                      ExportCountDepartment(submitExcelData);
                    }}
                    loading={loading}
                  />
                </div>
              </div>

              <div className="relative overflow-x-auto mt-3">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                      <th scope="col" className="px-6 py-3"></th>
                      {isAll ? (
                        <th
                          scope="col"
                          className={`px-6 py-3 ${
                            isAll ? null : "text-center"
                          }`}
                        >
                          Anesthesia
                        </th>
                      ) : null}
                      {isAll ? (
                        <th scope="col" className="px-6 py-3">
                          Interventional Radiology
                        </th>
                      ) : null}
                      {isAll ? (
                        <th scope="col" className="px-6 py-3">
                          Trauma
                        </th>
                      ) : null}
                      {isAll ? (
                        <th scope="col" className="px-6 py-3">
                          Pediatrics
                        </th>
                      ) : null}
                      {isAll ? (
                        <th scope="col" className="px-6 py-3">
                          Total
                        </th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 ">
                      {isAll ? (
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          Adult
                        </th>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.an?.adult}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.ir?.adult}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.tr?.adult}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.ped?.adult}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.adult}
                        </td>
                      ) : null}
                    </tr>
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      {isAll ? (
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          Child
                        </th>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.an?.kid}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.ir?.kid}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.tr?.kid}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.ped?.kid}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.kid}
                        </td>
                      ) : null}
                    </tr>

                    <tr className="bg-white dark:bg-gray-800">
                      {isAll ? (
                        <th
                          scope="row"
                          className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                        >
                          Total
                        </th>
                      ) : null}

                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.an}
                        </td>
                      ) : null}

                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.ir}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.tr}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.ped}
                        </td>
                      ) : null}
                      {isAll ? (
                        <td className="px-6 py-4 text-center">
                          {data?.total?.total}
                        </td>
                      ) : null}
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default ReportCountAllDepartment;
